import type {
  AnimationEases,
  AnimationKeyframe,
  AnimationOptions,
} from '../../types';

const defaultOptions: AnimationOptions = {
  duration: 200,
  easing: 'primary' as AnimationEases,
};

/**
 * @deprecated Avoid using this function as this module is deprecated.
 * A function which, given an animation defintion used in
 * usePresenceAnimation will resolve the correct duration
 * and easing configurations.
 * @param options Shared animation options
 * @param frame The animation, with its own options
 * @returns Resolved options
 */

export function resolveOptions(
  options: AnimationOptions,
  frame: AnimationKeyframe
): AnimationOptions {
  const { duration, easing, delay } = frame;
  const opts = {
    ...defaultOptions,
    ...options,
    duration,
    easing,
    delay,
  };

  return opts as AnimationOptions;
}

/**
 * @deprecated Avoid using this function as this module is deprecated.
 * Apply vapor's opinionated default animation options.
 * @param options Animation options
 * @returns Animation options
 */
export function applyDefaultOptions(
  options: AnimationOptions
): AnimationOptions {
  // create a new instance to avoid mutating the original complex instance
  const result = Object(options);
  const objectProto = Object.prototype;

  // iterate over the default options and apply them
  Object.keys(defaultOptions).forEach((key) => {
    const value = (result as any)[key];
    /**
     * If the value is undefined or the key does not exist in the result object
     * and the value is either equal to the prototype's value or both values are NaN
     * then set the default value.
     */
    if (
      value === undefined ||
      (!Object.hasOwn(result, key) &&
        (value === objectProto[key as keyof typeof objectProto] ||
          (Number.isNaN(value) &&
            Number.isNaN(objectProto[key as keyof typeof objectProto]))))
    ) {
      (result as any)[key] = (defaultOptions as any)[key];
    }
  });

  return result as AnimationOptions;
}
